import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import SendPasswordResetForm, { IFormValues } from 'views/auth/components/SendPasswordResetForm'
import { useApplicationStore } from 'hooks/application'
import api from 'helpers/api'
import { SIGN_IN } from 'routes'

const SendForgotPasswordLink: React.FC = () => {
  const [emailSubmitted, setEmailSubmitted] = useState(false)
  const { displayErrorMessage } = useApplicationStore()

  useEffect(() => {
    document.title = 'Morta | Forgot Password'
  }, [])

  const handlePasswordReset = async (values: IFormValues) => {
    try {
      await api.sendPasswordReset(values.email)
      setEmailSubmitted(true)
    } catch (e) {
      displayErrorMessage(e)
    }
  }

  return (
    <div className="bg-really-light-blue flex flex-1 items-center justify-center overflow-hidden box-border h-screen w-full px-8">
      <div className="h-fit flex flex-col bg-surface border border-divider-strong p-8 shadow-heavy rounded text-body w-[550px]">
        <h1 className="mb-8 text-2xl">Forgot password?</h1>
        {emailSubmitted ? (
          <div>
            <h2>Please check your email</h2>
            <p>We have sent an email to your account with details of how to reset your password</p>
            <p className="border-t border-divider mt-5 pt-5">
              Return to <Link to={SIGN_IN}>Sign In</Link>
            </p>
          </div>
        ) : (
          <div>
            <SendPasswordResetForm onSubmit={handlePasswordReset} />
          </div>
        )}
      </div>
    </div>
  )
}

export default SendForgotPasswordLink
